import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getData, putData } from '../Services/api'

const ProductMasterEdit = () => {
    const { id } = useParams();
    const [values, setValues] = useState({ product_name: "", product_code: "", packing_unit: "" });
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    }

    const fetchProduct = async () => {
        try {
            const res = await getData(`/product-master/${id}`);
            if (res.status) {
                setValues(res.data || {})
            }
        } catch (error) {
            console.log("error fetch product details", error)
        }
    }

    useEffect(() => {
        fetchProduct();
    }, [id])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            const res = await putData(`/product-master/update/${id}`, values);
            if (res.status) {
                toast.success(res.message || 'Product updated successfully');
                navigate('/product-master/product-list');
                setValues({ product_name: "", product_code: "", packing_unit: "" })
            } else {
                toast.error(res.message)
            }
        } catch (error) {
            console.log("error Product update", error)
            toast.error(error.response.data.message || 'error')
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/product-master/product-list">Product Master</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Edit Product
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Edit Product</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Edit Product</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Product Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Product Name"
                                                        name='product_name'
                                                        value={values.product_name}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12 mt-3">
                                                <div className="form-group">
                                                    <label className="form-label">Product Code</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Product Code"
                                                        name='product_code'
                                                        value={values.product_code}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12 mt-3">
                                                <div className="form-group">
                                                    <label className="form-label">Packing Unit</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Packing Unit (e.g. KG, Ltr, Pcs)"
                                                        name='packing_unit'
                                                        value={values.packing_unit}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-end btn-page mb-0 mt-4">
                                                <Link to="/product-master/product-list" className="btn btn-outline-secondary">Cancel</Link>
                                                <button className="btn btn-primary" type="submit" disabled={loading}>
                                                    {loading ? 'Saving...' : 'Save'}
                                                </button>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProductMasterEdit
